import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, AvatarFallback, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@mono/ui-components';
/**
 * Deterministically pick a readable colour from a string. Eight-colour palette
 * keeps contrast against background high enough to not need per-colour tuning.
 */ export function colorForUserId(id) {
    const palette = [
        '#ef4444',
        '#f97316',
        '#eab308',
        '#22c55e',
        '#06b6d4',
        '#3b82f6',
        '#8b5cf6',
        '#ec4899'
    ];
    let hash = 0;
    for(let i = 0; i < id.length; i++)hash = hash * 31 + id.charCodeAt(i) | 0;
    return palette[Math.abs(hash) % palette.length];
}
function initials(name, id = '') {
    const source = (name || id).trim();
    if (!source) return '?';
    const parts = source.split(/\s+/).filter(Boolean);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
/**
 * PresenceAvatars renders an overlapping avatar stack showing everyone
 * currently editing this document. The list is driven by ONLYOFFICE's user
 * events (see EditorPage). An empty stack means only you are in the session.
 */ export function PresenceAvatars({ users, max = 4 }) {
    if (users.length === 0) {
        return /*#__PURE__*/ _jsx("div", {
            className: "text-xs text-muted-foreground",
            children: "Only you"
        });
    }
    const visible = users.slice(0, max);
    const overflow = users.length - visible.length;
    return /*#__PURE__*/ _jsx(TooltipProvider, {
        delayDuration: 150,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center",
            children: [
                visible.map((u, i)=>/*#__PURE__*/ _jsxs(Tooltip, {
                        children: [
                            /*#__PURE__*/ _jsx(TooltipTrigger, {
                                asChild: true,
                                children: /*#__PURE__*/ _jsx(Avatar, {
                                    className: "h-7 w-7 border-2 border-background",
                                    style: {
                                        marginLeft: i === 0 ? 0 : -8,
                                        zIndex: visible.length - i
                                    },
                                    children: /*#__PURE__*/ _jsx(AvatarFallback, {
                                        className: "text-[10px] text-white",
                                        style: {
                                            backgroundColor: u.color
                                        },
                                        children: initials(u.name, u.id)
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(TooltipContent, {
                                children: u.name || u.id
                            })
                        ]
                    }, u.id)),
                overflow > 0 && /*#__PURE__*/ _jsxs("div", {
                    className: "h-7 w-7 -ml-2 rounded-full border-2 border-background bg-muted text-[10px] flex items-center justify-center text-foreground",
                    style: {
                        zIndex: 0
                    },
                    children: [
                        "+",
                        overflow
                    ]
                })
            ]
        })
    });
}
